import { BusinessUnit } from '../../enums';

class EventEditionHelper {
  private _businessUnitCode = '';
  private JAPANESE_BUSINESS_UNIT_CODE = BusinessUnit.JAPAN;

  get businessUnitCode(): string {
    return this._businessUnitCode;
  }

  set businessUnitCode(value: string) {
    this._businessUnitCode = value;
  }

  getIsJapaneseBusinessUnitCode() {
    return this._businessUnitCode === this.JAPANESE_BUSINESS_UNIT_CODE;
  }
}

export default new EventEditionHelper();
